export const userRights = [
  { label: 'CanActAs', value: 'CanActAs' }, // The user can act as a specific party.
  { label: 'CanReadAs', value: 'CanReadAs' }, // The user can read ledger data visible to a specific// party.
  { label: 'CanExecuteAs', value: 'CanExecuteAs' },
  // { label: 'CanReadAsAnyParty', value: 'CanReadAsAnyParty' },
  // { label: 'CanExecuteAsAnyParty', value: 'CanExecuteAsAnyParty' },
  // { label: 'IdentityProviderAdmin', value: 'IdentityProviderAdmin' }, // The user can administer users and parties
  // assigned to the same identity provider as the one of the user.
  // { label: 'ParticipantAdmin', value: 'ParticipantAdmin' }, // The user can administer the participant node
];

export enum UserRoles {
  CANTON_WRITER_ROLE = 'canton_writer',
  CANTON_VIEWER_ROLE = 'canton_viewer',
}

export type UserRolesTypes = UserRoles.CANTON_WRITER_ROLE | UserRoles.CANTON_VIEWER_ROLE;
